export default __webpack_public_path__ + "static/media/logo-white.824d6d90.png";